import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllProductResponse,
  getProductByIdResponse,
  getProductByCategoryIdResponse,
  searchProductByKeywordsResponse,
  addProductsInCartResponse,
  getProductByProductCodeResponse,
  bestSellingProductsResponse,
  getTopSellingProductsResponse,
  getActiveProductsResponse,
  getAllProductByCategoryIdResponse,
} from "../actions";

export function* createProductEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`product`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
     yield put(getProductByIdResponse(data));
    toast.success(data?.message || "Product added successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllProductEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`product/all`));
    yield put(getAllProductResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllProductResponse([]));
  }
}

export function* getTopSellingProductEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`product/top-selling`));
    yield put(getTopSellingProductsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getTopSellingProductsResponse([]));
  }
}

export function* getProductByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`product/${action?.payload?.id}`));
    yield put(getProductByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getProductByIdResponse([]));
  }
}

export function* deleteProductEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`product/${action?.payload?.id}`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Product deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* updateProductEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`product/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Product edited successfully");
    yield put(getProductByIdResponse(data));
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getProductByCategoryIdEffectSaga(action) {
  const {id} = action?.payload
  console.log(id)
  try {
    const { data } = yield call(() => axiosGet(`product/category/${id}`));
    console.log("productbycategoryid", data) 
    yield put(getProductByCategoryIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getProductByCategoryIdResponse([]));
  }
}


export function* getAllProductByCategoryIdEffectSaga(action) {
  const {id} = action?.payload
  console.log(id)
  try {
    const { data } = yield call(() => axiosGet(`product/all-product/${id}`));
    console.log("productbycategoryid", data) 
    yield put(getAllProductByCategoryIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllProductByCategoryIdResponse([]));
  }
}

export function* searchProductByKeywordsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`product/search?keywords=g`));
    yield put(searchProductByKeywordsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(searchProductByKeywordsResponse([]));
  }
}

export function* addProductsInCartEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`product/add-to-cart?productId=1&Quantity=3`)
    );
    yield put(addProductsInCartResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(addProductsInCartResponse([]));
  }
}

export function* getProductByProductCodeEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`product/product-code?productCode=PROD-1`)
    );
    yield put(getProductByProductCodeResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getProductByProductCodeResponse([]));
  }
}

export function* bestSellingProductsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`product/best-selling`));
    yield put(bestSellingProductsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(bestSellingProductsResponse([]));
  }
}

export function* getActiveProductsEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`product/active`));
    yield put(getActiveProductsResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getActiveProductsResponse([]));
  }
}

export function* productWatcherSaga() {
  yield takeLatest(types.CREATE_PRODUCT, createProductEffectSaga);
  yield takeLatest(types.GET_ALL_PRODUCT, getAllProductEffectSaga);
  yield takeLatest(types.GET_TOP_SELLING_PRODUCTS , getTopSellingProductEffectSaga)
  yield takeLatest(types.GET_PRODUCT_BY_ID, getProductByIdEffectSaga);
  yield takeLatest(types.DELETE_PRODUCT, deleteProductEffectSaga);
  yield takeLatest(types.UPDATE_PRODUCT, updateProductEffectSaga);
  yield takeLatest(types.GET_PRODUCT_BY_CATEGORY_ID, getProductByCategoryIdEffectSaga);
   yield takeLatest(types.GET_ALL_PRODUCT_BY_CATEGORY_ID, getAllProductByCategoryIdEffectSaga);
  yield takeLatest(types.GET_PRODUCT, searchProductByKeywordsEffectSaga);
  yield takeLatest(types.GET_PRODUCT, addProductsInCartEffectSaga);
  yield takeLatest(types.GET_PRODUCT, getProductByProductCodeEffectSaga);
  yield takeLatest(types.GET_PRODUCT, bestSellingProductsEffectSaga);
  yield takeLatest(types.GET_ACTIVE_PRODUCTS, getActiveProductsEffectSaga);
}
